export default __webpack_public_path__ + "static/media/hero-screenshot-2.dce3c09c.png";